<!-- auth.component.html -->
<div class="auth-page">
  <div class="auth-container" [class.pulse]="isLoading">

    <div class="auth-brand">
      <img src="./assets/logo.png" alt="Paul &amp; Sons logo">
    </div>

    <div class="auth-header">
      <h1>{{ authTitle }}</h1>
      <p>{{ authSubtitle }}</p>
    </div>

    <div class="auth-toggle">
      <a href="#" class="toggle-link" (click)="toggleAuthMode(); $event.preventDefault()">
        {{ toggleText }}
      </a>
    </div>

    <div class="user-type-tabs" *ngIf="!isLogin">
      <button
        class="tab-btn"
        [class.active]="userType === 'customer'"
        (click)="setUserType('customer')"
        type="button">
        <i class="icon-user"></i>
        Customer
      </button>
      <button
        class="tab-btn"
        [class.active]="userType === 'provider'"
        (click)="setUserType('provider')"
        type="button">
        <i class="icon-briefcase"></i>
        Service Provider
      </button>
    </div>

    <form [formGroup]="authForm" (ngSubmit)="onSubmit()" novalidate>
      <!-- Error Alert -->
      <div class="error-alert" *ngIf="loginError">
        <i class="icon-alert-circle"></i>
        <div>
          <strong>{{ isLogin ? 'Login Failed' : 'Registration Failed' }}</strong>
          <p>{{ loginError }}</p>
        </div>
        <button type="button" class="close-btn" (click)="loginError = null">×</button>
      </div>

      <!-- Full Name Field -->
      <div class="form-group" *ngIf="!isLogin" [@slideInOut]>
        <label for="name">First Name</label>
        <div class="input-wrapper">
          <input 
            type="text" 
            id="firstName"
            formControlName="firstName"
            class="form-control"
            [class.error]="getFieldError('firstName')"
            placeholder="Enter your first name"
            autocomplete="firstName">
          <i class="icon-user input-icon"></i>
        </div>
        <div class="error-message" *ngIf="getFieldError('firstName')">
          {{ getFieldError('firstName') }}
        </div>
      </div>

  <div class="form-group" *ngIf="!isLogin" [@slideInOut]> 
        <label for="lastName">Last Name</label>
        <div class="input-wrapper">
          <input 
            type="text" 
            id="lastName"
            formControlName="lastName"
            class="form-control"
            [class.error]="getFieldError('lastName')"
            placeholder="Enter your last name"
            autocomplete="lastName">
          <i class="icon-user input-icon"></i>
        </div>
        <div class="error-message" *ngIf="getFieldError('lastName')">
          {{ getFieldError('lastName') }}
        </div> 
        </div>

            <!-- Email Field -->
      <div class="form-group">
        <label for="email">User Name</label>
        <div class="input-wrapper">
          <input 
            type="username" 
            id="username"
            formControlName="username"
            class="form-control"
            [class.error]="getFieldError('username')"
            placeholder="Enter your username"
            autocomplete="username">
          <i class="icon-mail input-icon"></i>
        </div>
        <div class="error-message" *ngIf="getFieldError('username')">
          {{ getFieldError('username') }}
        </div>
      </div>
      
      
      <!-- Email Field -->
      <div class="form-group" *ngIf="!isLogin" [@slideInOut]> 
        <label for="email">Email Address</label>
        <div class="input-wrapper">
          <input 
            type="email" 
            id="email"
            formControlName="email"
            class="form-control"
            [class.error]="getFieldError('email')"
            placeholder="Enter your email"
            autocomplete="email">
          <i class="icon-mail input-icon"></i>
        </div>
        <div class="error-message" *ngIf="getFieldError('email')">
          {{ getFieldError('email') }}
        </div>
      </div>

      <!-- Password Field -->
      <div class="form-group">
        <label for="password">Password</label>
        <div class="input-wrapper">
          <input 
            [type]="showPassword ? 'text' : 'password'" 
            id="password"
            formControlName="password"
            class="form-control"
            [class.error]="getFieldError('password')"
            [placeholder]="isLogin ? 'Enter your password' : 'Create a strong password'"
            autocomplete="current-password">
          <i class="icon-lock input-icon"></i>
          <!-- <button 
            type="button" 
            class="password-toggle"
            (click)="togglePasswordVisibility()"
            [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
            <i [class]="showPassword ? 'icon-eye-off' : 'icon-eye'"></i>
          </button> -->
        </div>
        <div class="error-message" *ngIf="getFieldError('password')">
          {{ getFieldError('password') }}
        </div>
      </div>

      <!-- Phone Field -->
      <div class="form-group" *ngIf="!isLogin" [@slideInOut]>
        <label for="phone">Phone Number</label>
        <div class="input-wrapper">
          <input 
            type="tel" 
            id="phone"
            formControlName="phone"
            class="form-control"
            [class.error]="getFieldError('phone')"
            placeholder="Enter your phone number"
            autocomplete="tel">
          <i class="icon-phone input-icon"></i>
        </div>
        <div class="error-message" *ngIf="getFieldError('phone')">
          {{ getFieldError('phone') }}
        </div>
      </div>

      <!-- Address Field -->
      <div class="form-group" *ngIf="shouldShowAddressField" [@slideInOut]>
        <label for="address">Address</label>
        <div class="input-wrapper">
          <textarea 
            id="address"
            formControlName="address"
            class="form-control"
            [class.error]="getFieldError('address')"
            placeholder="Enter your address"
            rows="2"
            autocomplete="street-address"></textarea>
          <i class="icon-map-pin input-icon"></i>
        </div>
        <div class="error-message" *ngIf="getFieldError('address')">
          {{ getFieldError('address') }}
        </div>
      </div>

      <!-- Forgot Password Link -->
      <div class="forgot-password" *ngIf="isLogin">
        <a href="#" class="forgot-link">Forgot your password?</a>
      </div>

      <!-- Submit Button -->
      <button 
        type="submit" 
        class="btn-primary"
        [disabled]="isLoading"
        [class.loading]="isLoading">
        <span *ngIf="!isLoading">{{ submitButtonText }}</span>
        <div *ngIf="isLoading" class="loading-spinner">
          <div class="spinner"></div>
          <span>{{ submitButtonText }}</span>
        </div>
      </button>
    </form>

    <!-- Divider -->
    <div class="divider">
      <span>or continue with</span>
    </div>

    <!-- Social Login -->
    <div class="social-login">
      <button
        type="button"
        class="social-btn google"
        (click)="signInWithGoogle()"
        [disabled]="isLoading">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
        </svg>
        Google
      </button>
      <button
        type="button"
        class="social-btn apple"
        (click)="signInWithApple()"
        [disabled]="isLoading">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
        </svg>
        Apple
      </button>
    </div>

    <!-- Footer Links -->
    <div class="footer-links">
      <a href="#" routerLink="/privacy">Privacy Policy</a>
      <a href="#" routerLink="/terms">Terms of Service</a>
      <a href="#" routerLink="/help">Help Center</a>
    </div>
  </div>
</div>